import LoadPanel from "devextreme-react/load-panel";
import config from "devextreme/core/config";
import { loadMessages, locale } from "devextreme/localization";
import enMessages from "devextreme/localization/messages/en.json";
import plMessages from "devextreme/localization/messages/pl.json";
import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import { BrowserRouter as Router } from "react-router-dom";
import { Content } from "./Content";
import { AuthProvider, useAuth } from "./contexts/auth";
import { CompanyContextProvider } from "./contexts/company";
import { LoaderProvider } from "./contexts/loadingContext";
import { NavigationProvider } from "./contexts/navigation";
import { TutorialProvider } from "./contexts/tutorial";
import { licenseKey } from "./devextreme-license";
import en from "./locales/en.json";
import pl from "./locales/pl.json";
import { ThemeContext, useThemeContext } from "./theme/theme";
import { UnauthenticatedContent } from "./UnauthenticatedContent";
import { useScreenSizeClass } from "./utils/media-query";

config({ licenseKey });

const savedLocale = localStorage.getItem("locale") ?? "pl";
locale(savedLocale);
loadMessages(plMessages);
loadMessages(enMessages);

i18next.use(initReactI18next).init({
  lng: savedLocale,
  fallbackLng: "pl",
  resources: {
    pl,
    en,
  },
});

function Root() {
  const { user, loading } = useAuth();

  if (loading) {
    return <LoadPanel visible />;
  }

  if (!user) {
    return <UnauthenticatedContent />;
  }

  return <Content />;
}

export const Application = () => {
  const screenSizeClass = useScreenSizeClass();
  const themeContext = useThemeContext();

  return (
    <Router
      basename="/"
      future={{
        v7_startTransition: false,
        v7_relativeSplatPath: false,
      }}
    >
      <LoaderProvider>
        <ThemeContext.Provider value={themeContext}>
          <CompanyContextProvider>
            <AuthProvider>
              <TutorialProvider>
                <NavigationProvider>
                  <div className={`app ${screenSizeClass}`}>
                    {themeContext.isLoaded ? <Root /> : null}
                  </div>
                </NavigationProvider>
              </TutorialProvider>
            </AuthProvider>
          </CompanyContextProvider>
        </ThemeContext.Provider>
      </LoaderProvider>
    </Router>
  );
};
